/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EventOnlineView_onlineEvent$ref = any;
type GpxMediaList_gpxFileMedia$ref = any;
type GpxMediaList_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventGpsSearchPage_viewer$ref: FragmentReference;
declare export opaque type EventGpsSearchPage_viewer$fragmentType: EventGpsSearchPage_viewer$ref;
export type EventGpsSearchPage_viewer = {|
  +event: ?{|
    +id: string,
    +sgId: ?number,
    +gps: ?boolean,
    +hostResultUrl: ?string,
    +participant?: ?{|
      +media: ?{|
        +mediaInfo: ?{|
          +count: ?number
        |}
      |},
      +startnumber: ?string,
    |},
    +searchMediaByGpx: ?{|
      +mediaInfo: ?{|
        +count: ?number
      |},
      +$fragmentRefs: GpxMediaList_gpxFileMedia$ref,
    |},
    +secondFactorType: ?{|
      +type: ?string
    |},
    +searchByFace: ?boolean,
    +searchByFaceAsFeature: ?boolean,
    +smartSearch: ?boolean,
    +state: ?string,
    +$fragmentRefs: EventOnlineView_onlineEvent$ref & GpxMediaList_offer$ref,
  |},
  +$refType: EventGpsSearchPage_viewer$ref,
|};
export type EventGpsSearchPage_viewer$data = EventGpsSearchPage_viewer;
export type EventGpsSearchPage_viewer$key = {
  +$data?: EventGpsSearchPage_viewer$data,
  +$fragmentRefs: EventGpsSearchPage_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "count",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "EventGpsSearchPage_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "eventId",
      "type": "ID!"
    },
    {
      "kind": "RootArgument",
      "name": "language",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "startnumber",
      "type": "ID!"
    },
    {
      "kind": "RootArgument",
      "name": "secondFactor",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "noStartnumber",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "gpxFileId",
      "type": "ID!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "event",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "eventId"
        },
        {
          "kind": "Variable",
          "name": "language",
          "variableName": "language"
        }
      ],
      "concreteType": "Event",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sgId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "gps",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hostResultUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "searchMediaByGpx",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "gpxFileId",
              "variableName": "gpxFileId"
            }
          ],
          "concreteType": "ExtendedMediaConnection",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "GpxMediaList_gpxFileMedia",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "secondFactorType",
          "storageKey": null,
          "args": null,
          "concreteType": "SecondFactorType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchByFace",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchByFaceAsFeature",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "smartSearch",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "state",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "noStartnumber",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "participant",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "secondFactor",
                  "variableName": "secondFactor"
                },
                {
                  "kind": "Variable",
                  "name": "startnumber",
                  "variableName": "startnumber"
                }
              ],
              "concreteType": "Participant",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "media",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ExtendedMediaConnection",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "startnumber",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "EventOnlineView_onlineEvent",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "GpxMediaList_offer",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3ff4515221d4a58f87f5ef9df76785a';

module.exports = node;
